import React, { Component } from "react";
import {
  Col,
  Row,
  Form,
  Button,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import Pagination from "../Pagination/Pagination";
import classes from "./selectCandidate.module.css";
import search from "../../Assets/icons/0.75x/searchldpi.png";
import { connect } from "react-redux";
import * as actionTypes from "../../Action/Index";
import Loader from "react-loader-advanced";
import Spinner from "react-bootstrap/Spinner";
import NoDataErrorScreen from "../commonComponents/NoDataErrorScreen";
import ServerErrorScreen from "../commonComponents/ServerErrorScreen";
import "./progressbar.css";
import loading from "../../Assets/Images/loader-green.gif";
import SweetAlert from "../commonComponents/SweetAlert";
import NewSweetAlert from "react-bootstrap-sweetalert";
import "../commonComponents/SweetAlert.css";
import { withRouter } from "react-router-dom";
class jobProfile extends Component {
  state = {
    checked: false,
    currentPage: this.props.candidatePagePageinate,
    searchItem: [],
    viewSingleData: {},
    viewCandidateModal: false,
    error: "",
    viewResume: null,
    noResults: false,
    scheduleInterviewCandidateList: [],
    id: null,
  };
  componentWillReceiveProps(nextProps) {
    this.setState({
      noResults: nextProps.searchNoResults,
    });
    if (nextProps.candidate_cv_data !== this.state.viewResume) {
      this.setState({
        viewResume: nextProps.candidate_cv_data,
      });
    }
  }

  onPageChange = (id) => {
    this.setState(
      {
        currentPage: id,
      },
      () => {
        this.props.getScheduleCandidateList(
          this.state.currentPage,
          this.state.searchItem
        );
      }
    );
    this.props.candidatePageNumber(id);
  };
  onLeftChange = () => {
    if (this.state.currentPage === 1) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage - 1,
      },
      () => {
        this.props.getScheduleCandidateList(
          this.state.currentPage,
          this.state.searchItem
        );
      }
    );
    this.props.candidatePageNumber(this.state.currentPage - 1);
  };
  onRightChange = () => {
    if (this.props.records === this.state.currentPage) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage + 1,
      },
      () => {
        this.props.getScheduleCandidateList(
          this.state.currentPage,
          this.state.searchItem
        );
      }
    );
    this.props.candidatePageNumber(this.state.currentPage + 1);
  };

  // componentDidMount() {
  //     this.props.getScheduleCandidateList(this.state.currentPage);
  // }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // let searchFormData = event.target.search.value.split(",");
    // this.setState({
    //     searchItem: searchFormData,
    // })
    //    this.props.getScheduleCandidateList(this.state.currentPage, searchFormData)
  };

  componentDidMount() {
    this.props.getScheduleCandidateList(this.state.currentPage);
    this.setState({
      noResults: false,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.sufficientBalance != true) {
      this.props.history.push({
        pathname: "/interview",
      });
    }
    if (nextProps.scheduleInterviewCandidateList != null) {
      this.setState({
        scheduleInterviewCandidateList:
          nextProps.scheduleInterviewCandidateList,
      });
    }
  }

  searchHandler = () => {
    const str = this.searchField.value;
    const arr = str.split(",");
    this.props.searchScheduleCandidateProfile(arr);
  };
  searchHandler2 = (e) => {
    e.preventDefault();
    if (e.keyCode == 13) {
      const newarr = this.searchField.value;
      const arr = newarr.split(",");
      this.props.searchScheduleCandidateProfile(arr);
    }
  };

  setViewCandidateModal = (boolean, id) => {
    this.setState({
      viewCandidateModal: boolean,
      id: id,
    });
  };
  check = (event) => {
    let x = document.getElementsByTagName("tr");
    let i;
    for (i = 0; i < x.length; i++) {
      x[i].style.boxShadow = "none";
    }

    event.target.parentNode.parentNode.parentNode.style.boxShadow =
      "0px 0px 0px 1px #00a99d";
  };

  hideAlert = () => {
    this.setState({
      error: "",
    });
  };

  skills = "";
  render() {
    return (
      <>
        <Row>
          <Col md={12}>
            <div className={classes.heading}>
              <h3>Schedule Interview</h3>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-md-center">
          <Col md={9}>
            <ul className="progress-tracker progress-tracker--text progress-tracker--text-inline progress-tracker--spaced">
              <li className="progress-step is-complete">
                <div className="progress-marker" data-text="1">
                  <div className="progress-text">
                    <h6 className="progress-title color">Job Profile</h6>
                  </div>
                </div>
              </li>

              <li className="progress-step is-active">
                <div className="progress-marker" data-text="2">
                  <div className="progress-text">
                    <h6 className="progress-title color">Candidate Profile</h6>
                  </div>
                </div>
              </li>

              <li className="progress-step" aria-current="step">
                <div className="progress-marker" data-text="3">
                  <div className="progress-text">
                    <h6 className="progress-title">Interviewer</h6>
                  </div>
                </div>
              </li>

              <li className="progress-step">
                <div className="progress-marker" data-text="4">
                  <div className="progress-text">
                    <h6 className="progress-title">Interview Details</h6>
                  </div>
                </div>
              </li>
            </ul>
          </Col>
        </Row>
        <Row className={classes.gapTop}>
          <Col md={8}>
            <Form
              className="form-inline"
              onSubmit={(e) => this.handleSubmit(e)}
            >
              <Form.Group className="mx-sm-4">
                <Form.Control
                  type="text"
                  ref={(element) => (this.searchField = element)}
                  onKeyUp={(e) => this.searchHandler2(e)}
                  className={`${classes.inputText} shadow-none`}
                  maxLength="52"
                  name="search"
                  placeholder="Search by Candidate name"
                />
              </Form.Group>
              <Button
                type="button"
                onClick={() => this.searchHandler()}
                variant="warning"
                className={` ${classes.searchButton} ${classes.btnWarning} `}
              >
                {" "}
                <img
                  type="image/svg+xml"
                  src={search}
                  width="25px"
                  alt="search"
                />
              </Button>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.state.error !== "" ? (
              <NewSweetAlert
                style={{ width: "400px", marginLeft: "-210px" }}
                warning
                onConfirm={this.hideAlert}
                confirmBtnBsStyle="none"
                confirmBtnCssClass="confirmButtonStyle"
              >
                {this.state.error}
              </NewSweetAlert>
            ) : null}
            {/* <span className={classes.error}>&nbsp; {this.state.error}</span> */}
          </Col>
        </Row>
        <Loader
          show={this.props.loader}
          message={<img src={loading} />}
          foregroundStyle={{ color: "#00a99d" }}
          backgroundStyle={{ backgroundColor: "#F3EFEF" }}
        >
          {!this.props.serverErrorStatus ? (
            this.state.scheduleInterviewCandidateList.length !== 0 &&
            !this.props.scheduleInterviewCandidateNodata ? (
              <>
                <Row>
                  <Col md={12} className="table-responsive">
                    <table className={classes.scheduleTbl}>
                      <thead>
                        <tr>
                          <th> &nbsp; </th>
                          <th>Candidate Name</th>
                          <th>Experience</th>
                          {/* <th>Skills</th> */}
                          <th>Mobile Number</th>
                          <th>Candidate CV</th>
                        </tr>
                      </thead>
                      <tbody id="candidate">
                        {this.state.scheduleInterviewCandidateList.map(
                          (element) => {
                            const must = element.allSkillByOrder.map(
                              (el, index) => {
                                return index == element.allSkillByOrder.length
                                  ? el.value
                                  : " " + el.value;
                              }
                            );
                            this.skills = must.join();

                            let obj = {
                              id: element.id,
                              name: element.name,
                              experienceInYears: element.experienceInYears,
                              experienceInMonths: element.experienceInMonths,
                              email: element.email,
                              phone: element.mobile1,
                              mobileCountryCode1: element.mobileCountryCode1,
                            };
                            return (
                              <tr key={element.id}>
                                <td width="10%">
                                  <label className={classes.profile}>
                                    <input
                                      type="radio"
                                      required
                                      onClick={this.props.onRadioSelectCandidate.bind(
                                        this
                                      )}
                                      onChange={(e) => this.check(e)}
                                      value={JSON.stringify(obj)}
                                      name="candidate"
                                      checked={
                                        this.props.candidatePageValue.id ==
                                        element.id
                                      }
                                    />
                                    <span className={classes.checkmark}></span>
                                  </label>
                                </td>
                                <td
                                  onClick={() => {
                                    this.setViewCandidateModal(
                                      true,
                                      element.id
                                    );
                                    this.setState({ viewSingleData: element });
                                  }}
                                >
                                  {element.name}
                                </td>
                                <td
                                  onClick={() => {
                                    this.setViewCandidateModal(
                                      true,
                                      element.id
                                    );
                                    this.setState({ viewSingleData: element });
                                  }}
                                >
                                  {element.experienceInYears} years{" "}
                                  {element.experienceInMonths} months
                                </td>
                                {/* <td onClick={() => { this.setViewCandidateModal(true,element.id); this.setState({ viewSingleData: element }) }} >{this.skills.length > 25 ? this.skills.substring(0, 25) + "..." : this.skills}

                                                            </td> */}
                                <td
                                  onClick={() => {
                                    this.setViewCandidateModal(
                                      true,
                                      element.id
                                    );
                                    this.setState({ viewSingleData: element });
                                  }}
                                >
                                  {element.mobileCountryCode1}-{element.mobile1}
                                </td>
                                <td>
                                  {" "}
                                  <a
                                    href="JavaScript:Void(0);"
                                    onClick={() => {
                                      this.props.candidateDownloadFile(
                                        element.id
                                      );
                                    }}
                                    className={classes.desginColor}
                                  >
                                    View CV
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </Col>
                </Row>
                <div className={classes.footer}>
                  <Row>
                    <Col md={1}></Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        onClick={this.props.gotoJobProfile}
                        variant="warning"
                        className={classes.nextBtn}
                      >
                        {" "}
                        Previous{" "}
                      </Button>
                    </Col>
                    <Col md={6}>
                      {this.props.records > 1 ? (
                        <Pagination
                          activePage={this.state.currentPage}
                          pageRangeDisplayed={this.props.records}
                          onPageChange={this.onPageChange}
                          onLeftChange={this.onLeftChange}
                          onRightChange={this.onRightChange}
                        />
                      ) : null}
                    </Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        onClick={() => {
                          this.props.gotoSelectInterviewer();
                          this.setState({
                            error: "Please select a candidate profile",
                          });
                        }}
                        variant="warning"
                        className={classes.nextBtn}
                      >
                        {" "}
                        Next{" "}
                      </Button>
                    </Col>
                    <Col md={1}></Col>
                  </Row>
                </div>
                <br />
              </>
            ) : this.state.noResults ? (
              <NoDataErrorScreen msg="No results found" />
            ) : (
              <NoDataErrorScreen msg="No Candidate profile created yet" />
            )
          ) : (
            <ServerErrorScreen />
          )}
        </Loader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loader: state.employeeReducer.loader,
    scheduleInterviewCandidateList:
      state.employeeReducer.scheduleInterviewCandidateList,
    records: state.employeeReducer.SchedulecandidateRecords,
    serverErrorStatus: state.employeeReducer.candidateserverErrorStatus,
    scheduleInterviewCandidateNodata:
      state.employeeReducer.scheduleInterviewCandidateNodata,
    candidate_download_loader: state.employeeReducer.candidate_download_loader,
    candidate_download_status: state.employeeReducer.candidate_download_status,
    candidate_cv_data: state.employeeReducer.candidate_cv_data,
    candidate_download_err_msg:
      state.employeeReducer.candidate_download_err_msg,
    searchNoResults: state.employeeReducer.scheduleCandidateNoResults,
    sufficientBalance: state.employeeReducer.sufficientBalance,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getScheduleCandidateList: (page, searchItem) =>
      dispatch(actionTypes.getScheduleCandidateList(page, searchItem)),
    candidateDownloadFile: (id) =>
      dispatch(actionTypes.candidateDownloadFileSchedule(id)),
    searchScheduleCandidateProfile: (arr) =>
      dispatch(actionTypes.searchScheduleCandidateProfile(arr)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(jobProfile)
);
